import { useTheme } from "@mui/material";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import styles from "./MarkdownStyles.module.css";

type GeneralMarkdownProps = {
    answer: string;
};

function GeneralMarkdown({ answer }: GeneralMarkdownProps) {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    return (
        <Markdown
            className={`${styles.markdown} ${isDark ? styles.dark : styles.light}`}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
                a: ({ node, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer">
                        {props.children}
                    </a>
                )
            }}
        >
            {answer}
        </Markdown>
    );
}

export default GeneralMarkdown;
